import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Label,
} from "reactstrap";
import Swal from "sweetalert2";
import { FaCoins } from "react-icons/fa";

const SendTCoin = ({ currentCoins, onShareTcoins }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [coinAmount, setCoinAmount] = useState("");

  const toggleModal = () => setModalOpen(!modalOpen);

  const handleShare = () => {
    onShareTcoins(coinAmount);
    setModalOpen(false);
    setCoinAmount(""); // Reset input
  };

  return (
    <div
      onClick={toggleModal}
      role="button"
      className="text-primary d-inline-flex align-items-center"
    >
      <i className="fa fa-bitcoin"></i>

      <Modal isOpen={modalOpen} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}>Send T-Coins</ModalHeader>
        <ModalBody>
          <div className="text-center mb-3">
            <p>
              Current T-Coins: <strong>{currentCoins.toFixed(2)}</strong>
            </p>
          </div>
          <Label for="coinAmount">Enter Amount</Label>
          <Input
            type="number"
            id="coinAmount"
            value={coinAmount}
            onChange={(e) => setCoinAmount(e.target.value)}
            placeholder="Amount of T-Coins"
            max={currentCoins}
            min="1"
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={handleShare}
            disabled={!coinAmount || coinAmount <= 0}
          >
            Send
          </Button>
          <Button color="danger" onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default SendTCoin;
